<template>
  <section>
    <v-form ref="formBusqueda" @submit.prevent="buscarCitas">
      <v-layout row>
        <v-flex xs12 md2>
          <v-text-field
            clearable
            v-model="filtros.Folio"
            :disabled="!!filtros.Paciente"
            light
            outlined
            label="Folio"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field
            clearable
            v-model="filtros.Paciente"
            :disabled="!!filtros.Folio"
            light
            outlined
            label="Paciente"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md1>
          <v-btn
            :disabled="!filtros.Folio && !filtros.Paciente"
            fab
            type="submit"
            color="primary"
            dark
            ><v-icon dark color="white">search</v-icon></v-btn
          >
        </v-flex>
        <v-flex xs12 md6 class="text-right" align-self-center>
          <input
            accept=".xls,.xlsx,.csv"
            type="file"
            v-show="false"
            ref="uploadExcel"
            @change="subirArchivo($event)"
          />
          <v-btn
            v-if="esTomaMuestra"
            medium
            color="primary"
            @click.prevent="subirExcel"
            class="mr-3"
          >
            <v-icon>file_upload</v-icon> Cargar Excel
          </v-btn>
          <v-btn
            v-if="esTomaMuestra"
            medium
            color="primary"
            @click.prevent="nuevaMuestra"
            class="mr-3"
          >
            <v-icon>add</v-icon> Nueva Muestra
          </v-btn>
          <v-btn
            class="mr-3"
            medium
            color="primary"
            v-if="!esTomaMuestra"
            @click.prevent="abrirCalendario"
          >
            <v-icon>date_range</v-icon> Calendario
          </v-btn>
          <v-btn medium color="primary" @click.prevent="nuevaCita">
            <v-icon>add</v-icon> Nueva Cita
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout row v-if="esTomaMuestra" class="mt-2">
      <v-flex xs0 md10></v-flex>
      <v-flex xs12 md2 class="text-right">
        <v-switch
          hide-details
          class="ma-0 pa-0"
          label="Mostrar solo asignadas"
          v-model="soloAsignadas"
        ></v-switch>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-2">
      <v-flex xs12 md3>
        <v-card>
          <v-card-text>
            <v-sheet tile height="54" class="text-center">
              <v-layout row>
                <v-flex xs1>
                  <v-btn icon @click="$refs.calendar.prev()">
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs10 class="pl-14">
                  <v-btn @click.prevent="irHoy"> Hoy </v-btn>
                </v-flex>
                <v-flex xs1>
                  <v-btn icon @click="$refs.calendar.next()">
                    <v-icon>mdi-chevron-right</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-sheet>
            <v-sheet height="60vh">
              <v-calendar
                :categories="enfermerasCalendario"
                @click:event="irHora"
                :events="events"
                first-time="7"
                interval-minutes="60"
                locale="es-es"
                ref="calendar"
                v-model="fecha"
                type="day"
                @change="getEvents"
                event-color="primary"
              >
                <template v-slot:event="{ event }">
                  <span class="ml-2">{{ event.name }}</span>
                </template>
                <template v-slot:day-body="{ date, week }">
                  <div
                    class="v-current-time"
                    :class="{ first: date === week[0].date }"
                    :style="{ top: nowY }"
                  ></div>
                </template>
              </v-calendar>
            </v-sheet>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md9>
        <v-card>
          <v-card-text>
            <v-layout row v-if="seleccionMultiple.length">
              <v-flex xs12 class="text-right">
                <v-btn
                  class="mr-3"
                  small
                  color="error"
                  @click.prevent="cancelarMultiple"
                >
                  <v-icon>close</v-icon>
                  Cancelar Citas
                </v-btn>
              </v-flex>
            </v-layout>
            <v-simple-table fixed-header height="61vh">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th width="40"></th>
                    <th class="text-left primary--text">
                      Folio
                    </th>
                    <th class="text-left primary--text">
                      Cliente
                    </th>
                    <th class="text-left primary--text">
                      Fecha
                    </th>
                    <th class="text-left primary--text">
                      Hora
                    </th>
                    <th class="text-left primary--text">
                      Análisis
                    </th>
                    <th class="text-center primary--text">
                      Muestra Tomada
                    </th>
                    <th width="40"></th>
                  </tr>
                </thead>
                <tbody v-if="!citas.length">
                  <td colspan="5">
                    <div class="ma-3">
                      No se encontraron citas
                    </div>
                  </td>
                </tbody>
                <tbody v-else>
                  <template v-for="cita in citas">
                    <tr
                      :key="cita.CitaPersonaID"
                      @click.prevent="seleccionarCita(cita, $event)"
                      class="link"
                      :class="{
                        'error white--text': cita.AsignadoUsuario === 1,
                      }"
                    >
                      <td width="40">
                        <v-checkbox
                          :disabled="
                            (cita.Personas &&
                              cita.Personas.length > 1 &&
                              !cita.Personas.some(
                                (p) => p.MuestraTomada === 0
                              )) ||
                              cita.MuestraTomada === 1
                          "
                          @change="citaSeleccionadaChange(cita)"
                          v-model="cita.Seleccionada"
                        ></v-checkbox>
                      </td>
                      <td>
                        <v-chip class="ma-2 white--text" :color="cita.Color">
                          {{
                            cita.Personas.length > 1
                              ? cita.CitaID
                              : cita.CitaPersonaID
                          }}
                        </v-chip>
                      </td>
                      <td>
                        {{
                          cita.Personas.length > 1
                            ? cita.ConvenioNombre +
                              " (" +
                              cita.Personas.length +
                              " citas)"
                            : cita.Nombres + " " + cita.PrimerApellido
                        }}
                      </td>
                      <td>{{ getFechaMuestra(cita.FechaMuestra) }}</td>
                      <td>{{ getHoraMuestra(cita.FechaMuestra) }}</td>
                      <td>
                        <template
                          v-if="!cita.Personas || cita.Personas.length === 1"
                        >
                          <v-chip
                            class="ma-2"
                            color="primary"
                            v-if="cita.AnalisisPCR"
                          >
                            PCR
                          </v-chip>
                          <v-chip
                            class="ma-2"
                            color="primary"
                            v-if="cita.AnalisisAntigenos"
                          >
                            AG
                          </v-chip>
                          <v-chip
                            class="ma-2"
                            color="primary"
                            v-if="cita.AnalisisAnticuerpos"
                          >
                            AC
                          </v-chip>
                        </template>
                      </td>
                      <td class="text-center">
                        <template
                          v-if="!cita.Personas || cita.Personas.length === 1"
                        >
                          <v-icon
                            :color="
                              cita.AsignadoUsuario === 1 ? 'white' : 'primary'
                            "
                            v-if="cita.MuestraTomada === 1"
                            >done</v-icon
                          >
                          <v-icon
                            :color="
                              cita.AsignadoUsuario === 1 ? 'white' : 'error'
                            "
                            v-if="cita.MuestraTomada === 0"
                            >close</v-icon
                          >
                        </template>
                      </td>
                      <td>
                        <template v-if="cita.Personas.length > 1">
                          <v-icon v-if="cita.Expandido">expand_more</v-icon>
                          <v-icon v-else>chevron_right</v-icon>
                        </template>
                      </td>
                    </tr>
                    <template v-if="cita.Personas.length > 1">
                      <tr
                        v-show="cita.Expandido"
                        @click.prevent="seleccionarCita(persona, $event)"
                        v-for="persona in cita.Personas"
                        :key="'p' + persona.CitaPersonaID"
                        class="link"
                        :class="{
                          'error white--text': persona.AsignadoUsuario === 1,
                        }"
                      >
                        <td width="40">
                          <v-checkbox
                            :disabled="persona.MuestraTomada === 1"
                            @change="personaSeleccionadaChange(cita, persona)"
                            v-model="persona.Seleccionada"
                          ></v-checkbox>
                        </td>
                        <td>{{ persona.CitaPersonaID }}</td>
                        <td>
                          {{
                            persona.Nombres || persona.PrimerApellido
                              ? persona.Nombres + " " + persona.PrimerApellido
                              : " - "
                          }}
                        </td>
                        <td>{{ getFechaMuestra(persona.FechaMuestra) }}</td>
                        <td>{{ getHoraMuestra(persona.FechaMuestra) }}</td>
                        <td>
                          <v-chip
                            class="ma-2"
                            color="primary"
                            v-if="persona.AnalisisPCR"
                          >
                            PCR
                          </v-chip>
                          <v-chip
                            class="ma-2"
                            color="primary"
                            v-if="persona.AnalisisAntigenos"
                          >
                            AG
                          </v-chip>
                          <v-chip
                            class="ma-2"
                            color="primary"
                            v-if="persona.AnalisisAnticuerpos"
                          >
                            AC
                          </v-chip>
                        </td>
                        <td class="text-center">
                          <v-icon
                            :color="
                              persona.AsignadoUsuario === 1
                                ? 'white'
                                : 'primary'
                            "
                            v-if="persona.MuestraTomada === 1"
                            >done</v-icon
                          >
                          <v-icon
                            :color="
                              persona.AsignadoUsuario === 1 ? 'white' : 'error'
                            "
                            v-if="persona.MuestraTomada === 0"
                            >close</v-icon
                          >
                        </td>
                        <td></td>
                      </tr>
                    </template>
                  </template>
                </tbody>
                <v-menu
                  :position-x="menuX"
                  :position-y="menuY"
                  v-model="showMenu"
                  absolute
                  offset-y
                  style="max-width: 600px"
                >
                  <v-list
                    v-if="
                      !citaSeleccionada.Personas ||
                        citaSeleccionada.Personas.length <= 1
                    "
                  >
                    <v-list-item link @click.prevent="duplicarCita">
                      <v-list-item-title>Duplicar Cita</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="
                        esTomaMuestra && citaSeleccionada.MuestraTomada === 1
                      "
                      link
                      @click.prevent="irMuestra"
                    >
                      <v-list-item-title>Ver Muestra</v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click.prevent="irCita">
                      <v-list-item-title>Ver Cita</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="
                        esTomaMuestra && citaSeleccionada.MuestraTomada === 0
                      "
                      link
                      :to="
                        '/digitrack/nueva-muestra/' +
                          citaSeleccionada.CitaPersonaID +
                          '/'
                      "
                    >
                      <v-list-item-title>Tomar Muestra</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="citaSeleccionada.MuestraTomada == 0"
                      link
                      @click.prevent="cancelarCita"
                    >
                      <v-list-item-title class="error--text"
                        >Cancelar Cita</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-simple-table>
            <v-layout row>
              <v-flex xs12 class="primary--text text-center">
                RESPONSABLES DE MUESTRA:
                <v-chip
                  class="ml-2 mr-2 white--text"
                  v-for="e in enfermeras"
                  :color="e.Color"
                  :key="e.UsuarioID"
                >
                  {{ e.Iniciales }}
                </v-chip>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <muestras-excel
      @cerrar="cerrarMuestrasExcel"
      :datos="datosExcel"
      v-if="mostrarMuestrasExcel"
    ></muestras-excel>
    <calendario-enfermeras
      v-if="mostrarCalendario"
      @cerrar="cerrarCalendario"
    ></calendario-enfermeras>
  </section>
</template>

<script>
import ServicioCitas from "../../services/citas";
import ServicioUpload from "../../services/upload";
import MuestrasExcel from "../MuestrasExcel.vue";
import CalendarioEnfermeras from "./CalendarioEnfermeras.vue";
export default {
  components: { MuestrasExcel, CalendarioEnfermeras },
  name: "Citas",
  data() {
    return {
      fecha: "",
      ready: false,
      citasTodas: [],
      events: [],
      filtros: { Folio: "", Paciente: "" },
      showMenu: false,
      citaSeleccionada: {},
      lastStart: null,
      lastEnd: null,
      soloAsignadas: false,
      menuX: 0,
      menuY: 0,
      seleccionMultiple: [],
      mostrarMuestrasExcel: false,
      datosExcel: null,
      enfermeras: [],
      mostrarCalendario: false,
    };
  },
  computed: {
    enfermerasCalendario() {
      return this.enfermeras.map((e) => e.Iniciales);
    },
    cal() {
      return this.ready ? this.$refs.calendar : null;
    },
    nowY() {
      return this.cal ? this.cal.timeToY(this.cal.times.now) + "px" : "-10px";
    },
    citas() {
      let citas = [];
      if (this.soloAsignadas) {
        citas = this.citasTodas.filter((cita) => cita.AsignadoUsuario);
      } else {
        citas = this.citasTodas;
      }
      let res = [];
      for (let i = 0; i < citas.length; i++) {
        const cita = res.find((c) => c.CitaID === citas[i].CitaID);
        if (cita) {
          cita.Personas.push({ ...citas[i] });
        } else {
          res.push({
            ...citas[i],
            Personas: [{ ...citas[i] }],
            Expandido: false,
          });
        }
      }
      return res;
    },
    esTomaMuestra() {
      return this.$route.name === "Toma de Muestra";
    },
  },
  mounted() {
    this.ready = true;
    this.scrollToTime();
    this.updateTime();
    if (
      localStorage.getItem("citas-filtros") ||
      localStorage.getItem("citas-fechas")
    ) {
      let filtros = localStorage.getItem("citas-filtros");
      let fechas = localStorage.getItem("citas-fechas");
      if (filtros) {
        filtros = JSON.parse(filtros);
        this.filtros = filtros;
        this.buscarCitas();
      } else if (fechas) {
        fechas = JSON.parse(fechas);
        console.log("fechas", fechas);
        this.lastStart = fechas.start;
        this.lastEnd = fechas.end;
        this.fecha = this.lastStart.date;
        this.getEvents({ start: this.lastStart, end: this.lastEnd });
      }
    }

    localStorage.removeItem("citas-filtros");
    localStorage.removeItem("citas-fechas");
  },
  methods: {
    cerrarCalendario() {
      this.mostrarCalendario = false;
    },
    abrirCalendario() {
      this.mostrarCalendario = true;
    },
    duplicarCita() {
      this.$router.push(
        "/digitrack/duplicar-cita/" + this.citaSeleccionada.CitaID
      );
    },
    cerrarMuestrasExcel(recargar) {
      this.mostrarMuestrasExcel = false;
      if (recargar) {
        this.getEvents({ start: this.lastStart, end: this.lastEnd });
      }
    },
    async cancelarMultiple() {
      this.confirmar(
        "Cancelar Citas",
        `Desea cancelar ${this.seleccionMultiple.length} citas?`
      ).then(async () => {
        const citas = this.seleccionMultiple.map((c) => {
          return { CitaPersonaID: c.CitaPersonaID };
        });
        const res = await ServicioCitas.cancelarCitas(citas);
        if (res.data.result === 1) {
          this.$root.mensajeExito = "Las citas se cancelaron correctamente";
          this.seleccionMultiple = [];
          this.getEvents({ start: this.lastStart, end: this.lastEnd });
        } else {
          this.$root.mensajeError = res.data.message;
        }
      });
    },
    personaSeleccionadaChange(cita, persona) {
      const todas = !cita.Personas.some((p) => !p.Seleccionada);
      cita.Seleccionada = todas;

      if (persona.Seleccionada) {
        if (persona.MuestraTomada === 0) this.seleccionMultiple.push(persona);
      } else {
        const ix = this.seleccionMultiple.indexOf(persona);
        if (ix > -1) {
          this.seleccionMultiple.splice(ix, 1);
        }
      }
    },
    citaSeleccionadaChange(cita) {
      if (cita.Personas && cita.Personas.length) {
        cita.Personas.forEach((p) => {
          p.Seleccionada = !!cita.Seleccionada;
          if (cita.Seleccionada) {
            if (p.MuestraTomada === 0) this.seleccionMultiple.push(p);
          } else {
            const ix = this.seleccionMultiple.indexOf(p);
            if (ix > -1) {
              this.seleccionMultiple.splice(ix, 1);
            }
          }
        });
      } else if (cita.Seleccionada) {
        if (cita.MuestraTomada === 0) this.seleccionMultiple.push(cita);
      } else {
        const ix = this.seleccionMultiple.indexOf(cita);
        if (ix > -1) {
          this.seleccionMultiple.splice(ix, 1);
        }
      }
    },
    async subirArchivo(ev) {
      if (ev.target.files.length) {
        const archivo = ev.target.files[0];
        const res = await ServicioUpload.uploadExcelMuestras(archivo);
        if (res.data.result === 1) {
          this.datosExcel = res.data.data;
          this.mostrarMuestrasExcel = true;
        } else {
          this.$root.mensajeError =
            res.data.message || "Error al subir el archivo.";
        }
      }
      this.$refs.uploadExcel.value = null;
    },
    subirExcel() {
      this.$refs.uploadExcel.click();
    },
    irMuestra() {
      this.respaldarFiltros();
      this.$router.push(
        "/digitrack/info-muestra/" + this.citaSeleccionada.MuestraID
      );
    },
    irCita() {
      this.respaldarFiltros();
      this.$router.push("/digitrack/info-cita/" + this.citaSeleccionada.CitaID);
    },
    async getEvents({ start, end }) {
      this.lastStart = start;
      this.lastEnd = end;
      const min = `${start.date}T00:00:00`;
      const max = `${end.date}T23:59:59`;

      this.seleccionMultiple = [];
      const resCitas = await ServicioCitas.getCitasFecha(min, max);
      this.citasTodas = resCitas.data.data.Table0;
      this.enfermeras = resCitas.data.data.Table1;

      const resHoras = await ServicioCitas.getHorasCitas(start.date);
      const tablaHoras = resHoras.data.data.Table0;
      let events = [];
      for (let i = 5; i <= 20; i++) {
        const c = tablaHoras.filter((obj) => obj.Hora === i && obj.Citas > 0);
        c.forEach((obj) => {
          const hora = i > 9 ? String(i) : `0${i}`;
          const estart = new Date(`${start.date}T${hora}:00:00`);
          const eend = new Date(`${start.date}T${hora}:59:59`);
          let name = `${obj.Citas} cita${obj.Citas > 1 ? "s" : ""}`;
          if (obj.CitasUsuario > 0) {
            name += ` (${obj.CitasUsuario} asignadas)`;
          }
          events.push({
            name,
            start: estart,
            end: eend,
            color: obj.Color,
            timed: true,
            category: obj.Iniciales,
            Enfermera_UsuarioID: obj.Enfermera_UsuarioID,
          });
        });
      }
      this.events = events;
    },
    getCurrentTime() {
      return this.cal
        ? this.cal.times.now.hour * 60 + this.cal.times.now.minute
        : 0;
    },
    scrollToTime() {
      const time = this.getCurrentTime();
      const first = Math.max(0, time - (time % 30) - 30);

      this.cal.scrollToTime(first);
    },
    updateTime() {
      setInterval(() => this.cal.updateTimes(), 60 * 1000);
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    nuevaCita() {
      this.respaldarFiltros();
      this.$router.push("nueva-cita");
    },
    async buscarCitas() {
      let resCitas;
      if (this.filtros.Folio) {
        resCitas = await ServicioCitas.getCitasFolio(this.filtros.Folio);
      } else {
        resCitas = await ServicioCitas.getCitasNombre(this.filtros.Paciente);
      }
      this.seleccionMultiple = [];
      this.citasTodas = resCitas.data.data.Table0;
      this.enfermeras = resCitas.data.data.Table1;
    },
    getFechaMuestra(fecha) {
      const date = new Date(fecha);
      return this.formatDate(this.fechaPicker(date));
    },
    getHoraMuestra(fecha) {
      const date = new Date(fecha);
      return this.horaFecha(date);
    },
    irHoy() {
      if (this.fecha) {
        this.fecha = "";
      } else {
        this.getEvents({ start: this.lastStart, end: this.lastEnd });
      }
    },
    seleccionarCita(cita, ev) {
      const clase = ev.target.classList.value;
      if (clase.indexOf("v-input") > -1) {
        return;
      }
      this.citaSeleccionada = cita;
      if (!!cita.Personas && cita.Personas.length > 1) {
        cita.Expandido = !cita.Expandido;
      } else {
        if (!this.showMenu) {
          this.menuX = ev.clientX;
          this.menuY = ev.clientY;
          this.showMenu = true;
        } else {
          this.showMenu = false;
        }
      }
    },
    async cancelarCita() {
      this.confirmar(
        "Cancelar Cita",
        "Desea cancelar la cita seleccionada?"
      ).then(async () => {
        const resCancelar = await ServicioCitas.cancelarCita(
          this.citaSeleccionada.CitaPersonaID
        );
        if (resCancelar.data.result === 1) {
          const ix = this.seleccionMultiple.indexOf(this.citaSeleccionada);
          if (ix > -1) {
            this.seleccionMultiple.splice(ix, 1);
          }
          this.$root.mensajeExito = "La cita fué cancelada con éxito";
          this.citasTodas.splice(
            this.citasTodas.indexOf(this.citaSeleccionada),
            1
          );
        } else {
          this.$root.mensajeError = resCancelar.data.message;
        }
      });
    },
    async irHora(evento) {
      const start = `${evento.eventParsed.start.date}T${evento.eventParsed.start.time}`;
      const end = `${
        evento.eventParsed.start.date
      }T${evento.eventParsed.start.time.replace("00", "59")}`;
      const enfermeraID = evento.eventParsed.input.Enfermera_UsuarioID;

      const citasRes = await ServicioCitas.getCitasFecha(
        start,
        end,
        enfermeraID
      );
      this.seleccionMultiple = [];
      this.citasTodas = citasRes.data.data.Table0;
      this.enfermeras = citasRes.data.data.Table1;
    },
    nuevaMuestra() {
      this.respaldarFiltros();
      this.$router.push("nueva-muestra/0");
    },
    respaldarFiltros() {
      localStorage.removeItem("citas-filtros");
      localStorage.removeItem("citas-fechas");
      if (this.filtros.Folio || this.filtros.Paciente) {
        localStorage.setItem("citas-filtros", JSON.stringify(this.filtros));
      }
      localStorage.setItem(
        "citas-fechas",
        JSON.stringify({ start: this.lastStart, end: this.lastEnd })
      );
    },
  },
  watch: {
    filtros: {
      async handler() {
        if (!this.filtros.Folio && !this.filtros.Paciente) {
          await this.getEvents({ start: this.lastStart, end: this.lastEnd });
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: "";
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}
</style>
